// 두 리소스 묶음(태그·현재 릴리스) 간 기본 카드 비교. 카드 ID 불변 정책에 따라 카드 ID로 대응시킨다.
import type { ResourceSet, VersionCard } from './version-types';

export type CardChange = 'text' | 'category' | 'imageResource' | 'image';

export interface CardDiff {
  added: VersionCard[];
  removed: VersionCard[];
  changed: { before: VersionCard; after: VersionCard; changes: CardChange[] }[];
  unchangedCount: number;
}

const allCards = (s: ResourceSet) => s.categories.flatMap((c) => c.cards);

export function diffResourceSets(base: ResourceSet, head: ResourceSet): CardDiff {
  const before = new Map(allCards(base).map((c) => [c.id, c]));
  const after = new Map(allCards(head).map((c) => [c.id, c]));
  const out: CardDiff = { added: [], removed: [], changed: [], unchangedCount: 0 };
  for (const [id, a] of after) {
    const b = before.get(id);
    if (!b) {
      out.added.push(a);
      continue;
    }
    const changes: CardChange[] = [];
    if (b.text !== a.text) changes.push('text');
    if (b.category !== a.category) changes.push('category');
    if (b.imageResourceId !== a.imageResourceId) changes.push('imageResource');
    // 같은 리소스 ID인데 파일 내용(sha256)이 다르면 이미지 교체. 해시를 모르면 판단하지 않는다.
    else if (b.image?.hash && a.image?.hash && b.image.hash !== a.image.hash) changes.push('image');
    else if (!!b.image !== !!a.image) changes.push('image');
    if (changes.length) out.changed.push({ before: b, after: a, changes });
    else out.unchangedCount++;
  }
  for (const [id, b] of before) if (!after.has(id)) out.removed.push(b);
  return out;
}

export const CHANGE_LABEL: Record<CardChange, string> = {
  text: '문구',
  category: '카테고리',
  imageResource: '이미지 리소스',
  image: '이미지 파일',
};
